import CmgHeaderUserIcon from '../components/CmgHeader/CmgHeaderUserIcon/CmgHeaderUserIcon.vue';
import CmgHeaderActionsRight from '../components/CmgHeader/CmgHeaderActionsRight/CmgHeaderActionsRight.vue';
import CmgHeaderFindAChipotle from '../components/CmgHeader/CmgHeaderFindAChipotle/CmgHeaderFindAChipotle.vue';
import CmgFeatured from '@/components/CmgFeatured/CmgFeatured.vue';
import CmgCountryFlag from '@/components/CmgCountryFlag/CmgCountryFlag.vue';
import CmgRecentAndFavoriteOrdersMini from '@/components/recent-and-favorite-orders/CmgRecentAndFavoriteOrdersMini/CmgRecentAndFavoriteOrdersMini.vue';
import CmgHeaderHamburgerIcon from '@/components/CmgHeader/CmgHeaderHamburgerIcon/CmgHeaderHamburgerIcon.vue';
import axios from 'axios';


export interface AemIdComponent {
  id: string;
  component: any;
}

const AEMComponents : AemIdComponent[] = [
  // { id: '#aem-header-user-icon', component: CmgHeaderUserIcon },
  { id: '#aem-header-actions-right', component: CmgHeaderActionsRight },
  // { id: '#aem-header-find-a-chipotle', component: CmgHeaderFindAChipotle },
  { id: '#aem-header-hamburger-icon', component: CmgHeaderHamburgerIcon},
  // { id: '#aem-favorites-recents', component: CmgRecentAndFavoriteOrdersMini },
  // { id: '#aem-featured-meals', component: CmgFeatured },
  { id: '#aem-country-modal', component: CmgCountryFlag }
];

const AEMIds = AEMComponents.map(n => n.id);
const AEMAppIdsToHide = ['#aem-xf-header', '#aem-xf-footer'];
const AEMHomepageIds = ['#aem-xf-hero', '#aem-xf-tout', '#aem-xf-crowd-pleasers'];
const AEMHomepageXfs = [
  {
    id: 'aem-xf-hero',
    url: '/content/experience-fragments/chipotle/us/en/xf-homepage-hero/master.html',
    rootSelector: '.hero',
    cb: function(html: HTMLElement) {
      let placeholder = document.querySelector('.aem-home > .noo-hero-goes-here');
      if( placeholder ) {
        placeholder.insertAdjacentElement('afterbegin', html);
        setTimeout(() => {
          if( window.CHIPW && window.CHIPW.ui && window.CHIPW.ui.lazyloadVideo ) {
            console.log("Attempting to load hero video");
            window.CHIPW.ui.lazyloadVideo(document.querySelector('.hero video'));
          }
        }, 500);
      } else {
        console.warn("Failed to load AEM XF Hero on homepage");
      }
    },
  },
];

// Dynamically request XF's
async function getAemXfHtml (url: string, rootSelector: string) {
  
  return await axios.get(url)
  .then((res)=>{
    if(res && res.data){
      let xf = new DOMParser().parseFromString(res.data, "text/html");
      return rootSelector ? xf.querySelector(rootSelector) : xf;
    }
  }).catch((err) => {
    console.log('error fetching homepage hero', err)
    return null;
  });
}

export {AEMComponents, AEMIds, AEMAppIdsToHide, AEMHomepageIds, AEMHomepageXfs, getAemXfHtml}